import React from 'react';

export default ({ handleSortClick, order, sortedBy, deleteComponents, familyComponents, deleteAllComponents }) => {
  function createClasses(key) {
    if (sortedBy === key) return `${order ? 'asc' : 'desc'} active`;
    return '';
  }

  return (
    <div className='list__row list__header list__header_small _margin_top_20'>
      <div className={'list-scene__table-header-element _width_pc_8'}></div>
      <div
        className={`list-scene__table-header-element ${createClasses('id')} _width_pc_12`}
        onClick={handleSortClick('id')}
      >
        <div>ID</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses(
          'description'
        )} list-scene__table-row-element_place_filler`}
        onClick={handleSortClick('description')}
      >
        <div>Description</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div
        className={`list-scene__table-header-element ${createClasses('applicationStatus')} _width_pc_18`}
        onClick={handleSortClick('applicationStatus')}
      >
        <div>Status</div>
        <div className='list-scene__table-header-element-sort-arrow' />
      </div>

      <div className={'list-scene__table-header-element _width_pc_12 _cursor_pointer'} onClick={deleteAllComponents}>
        <div>Remove</div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/ComponentFamily/New/ComponentList/TableHeader.jsx